<template>
	<div>
		<v-layout row wrap justify-end
			align-center class="header-booking-data">
			<amounts-component :subsidiary-id="params.subsidiaryId" />
			<v-flex xs2>
				<v-select
					class="filter-select"
					hide-details
					item-text="name"
					item-value="id"
					:items="subsidiaries"
					single-line
					v-model="params.subsidiaryId"
					@input="onChangeHotel"
				>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout row wrap
			align-center mb-3>
			<v-flex xs12>
				<v-layout row wrap align-center justify-start>
					<v-flex xs2>
						<v-select
							class="filter-select"
							item-text="nameBuild"
							item-value="id"
							label="Edificio"
							:items="buildings"
							v-model="params.buildingId"
							@input="loadFloors"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs2>
						<v-select
							class="filter-select"
							item-text="name"
							item-value="id"
							label="Tipo Hab."
							:items="roomTypes"
							v-model="params.roomtypesId"
							@input="loadData"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs2>
						<v-select
							class="filter-select"
							item-text="name"
							item-value="id"
							label="Estado"
							:items="statesFilter"
							v-model="params.stateId"
							@input="loadData"
							hide-details
							single-line
							bottom>
						</v-select>
					</v-flex>
					<v-flex xs4 offset-xs2>
						<v-layout row wrap justify-space-between>
							<v-flex xs7 text-xs-left>
								<v-btn
									class="action-btn pr-1"
									:disabled="roomsNotSelected"
									@click.native.stop="openModal">
									Editar
								</v-btn>
								<v-btn
									class="action-btn"
									:disabled="roomsNotSelected"
									@click="cleanData">
									Limpiar
								</v-btn>
							</v-flex>
							<v-flex xs5>
								<v-btn 
									class="reservation-btn" 
									:disabled="!disabledReservation"
									@click="reservation">
									<v-icon class="icon">add</v-icon>
									Reserva
								</v-btn>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<div class="planning-container">
			<v-layout row wrap align-center py-3 class="border-bottom">
				<v-flex xs12>
					<v-layout row wrap justify-end
						align-center class="caption pl-1">
						<div
							class="text-xs-left pr-4"
							v-for="caption in states"
							:key="caption.id">
							<span class="color"
								:style="`background-color: ${caption.colorState}`"></span>
							<label class="title">{{ caption.name }}</label>
						</div>
						<div class="text-xs-left pr-4">
							<span class="circle-booking">
								<img :src="`${$imageS3}/clerkinn/booking-icon.svg`" alt="">
							</span>
							<label class="title">Reservado</label>
						</div>
					</v-layout>
				</v-flex>
			</v-layout>
			<v-layout row wrap mt-3>
				<v-flex xs12 text-xs-left>
					<room-status
						v-for="room in rooms"
						:key="room.id"
						:background-color="room.colorState"
						:clean-state="room.cleanState"
						:code="room.codeRoomtype"
						:extra-state="room.extraState"
						:label-for="`room-${room.id}`"
						:number="room.codeRoom"
						:room="room"
						:show-circle="true"
						:status-icon-img="room.iconUrl"
						@on-room-selected="roomIsSelected">
					</room-status>
				</v-flex>
			</v-layout>
			<v-layout row justify-center>
				<v-dialog
					v-model="dialog"
					persistent
					:width="685">
					<v-card class="modal-card">
						<v-card-title class="headline">Cambiar de estado</v-card-title>
						<v-card-text>
							<v-layout row wrap align-center px-2
								justify-start class="modal-row">
								<v-flex xs12 text-xs-left py-2>
									<label class="modal-title">
										Habitaciones seleccionadas
									</label>
								</v-flex>
								<v-flex xs12 text-xs-left>
									<room-status
										v-for="room in roomsSelected"
										:key="room.id"
										:background-color="room.colorState"
										:clean-state="room.cleanState"
										:code="room.codeRoomtype"
										:extra-state="room.extraState"
										:label-for="`room-${room.id}`"
										:number="room.codeRoom"
										:room="room"
										:show-circle="true"
										:status-icon-img="room.iconUrl"
										@on-room-selected="roomIsSelected">
									</room-status>
								</v-flex>
							</v-layout>
							<v-layout row wrap align-center justify-center>
								<v-icon info x-large>arrow_downward</v-icon>
							</v-layout>
							<v-layout row wrap align-center px-2
								justify-start class="modal-row">
								<v-flex xs12 text-xs-left py-2>
									<label class="modal-title">
										Define el estado de las habitaciones
									</label>
								</v-flex>
								<v-flex xs12 text-xs-left>
									<v-layout row wrap align-center>
										<room-status
											v-for="state in states"
											:key="state.id"
											:background-color="state.colorState"
											:clean-state="state.clean_state"
											:code="state.code_roomtype"
											:extra-state="state.extra_state"
											:label-for="`state-${state.id}`"
											:name="state.name"
											:number="state.number"
											:room="state"
											:status-icon-img="state.icon_url"
											@on-room-selected="stateIsSelected">
										</room-status>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-card-text>
						<v-card-actions>
							<v-layout row wrap align-center justify-end>
								<v-flex xs3 pr-1>
									<v-btn
										error
										class="white--text"
										@click.native="closeModal">
										Cancelar
									</v-btn>
								</v-flex>
								<v-flex xs3 pl-1>
									<v-btn
										info
										class="white--text"
										:disabled="roomsNotSelected"
										@click.native="changeState">
										Cambiar
									</v-btn>
								</v-flex>
							</v-layout>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import { addDays, format } from 'date-fns';
	import { round } from '@/shared/filters';
	import mixin from '@/shared/mixins';
	import amountsComponent from '@/components/shared/AmountsComponent';
	import RoomStatus from '@/components/shared/RoomStatus';

	function created() {
		this.loadStates();
		this.loadHotel();
	}

	async function changeState() {
		const modelSend = {
			idState: this.stateSelected.id,
			rooms: this.roomsSelected.map((room) => {
				const newRoom = { ...room };
				return newRoom.id;
			}),
		};
		await this.$http.put(`${process.env.PMS_URL}/rooms-state`, modelSend);
		this.showNotification('El estado de las habitaciones se actualizó correctamente.', 'success');
		this.closeModal();
		this.loadData();
	}

	function cleanData() {
		this.rooms = this.rooms.map((room) => {
			const newRoom = { ...room };
			newRoom.isSelected = false;
			return newRoom;
		});
		this.roomsSelected = [];
	}

	function closeModal() {
		this.dialog = false;
	}

	function disabledReservation() {
		return this.roomsSelected.length === 1;
	}

	function floorsEmpty() {
		return this.floors.length === 0;
	}

	async function loadBuilding() {
		const subsidiaryId = this.params.subsidiaryId;
		const { data: buildings } = await this.$http.get(`${process.env.PMS_URL}/building`,
			{ params: { subsidiaryId } });
		this.params.buildingId = 0;
		this.buildings = [
			{ id: 0, nameBuild: 'Todos' },
		];
		buildings.data.forEach((building) => {
			this.buildings.push(building);
		});
	}

	async function loadData() {
		this.params.date = format(new Date(), 'YYYY-MM-DD');
		if (this.params.buildingId === 0) {
			delete this.params.buildingId;
		}
		if (this.params.floorId === 'Todos') {
			delete this.params.floorId;
		}
		if (this.params.roomtypesId === 0) {
			delete this.params.roomtypesId;
		}
		if (this.params.stateId === 0) {
			delete this.params.stateId;
		}
		if (this.params.subsidiaryId > 0) {
			const { data: rooms } = await this.$http.get(`${process.env.PMS_URL}/rooms-planning`, { params: this.params });
			this.rooms = rooms.data.map((room) => {
				const newRoom = { ...room };
				newRoom.isAdded = false;
				newRoom.isSelected = false;
				newRoom.colorState = room.msState ? room.msState.data.colorState : '#000000';
				newRoom.codeRoomtype = room.roomTypes ? room.roomTypes.data.codeRoomtype : '';
				newRoom.extraState = room.flagBooking ? 'booking' : null;
				newRoom.iconUrl = room.msState ? room.msState.data.iconUrl : '';
				return newRoom;
			});
		}
	}

	function loadFloors(id) {
		this.loadRoomtype(id);
		delete this.params.floorId;
		if (id > 0) {
			const numFloors = this.buildings.find(b => b.id === id).floors;
			this.floors = ['Todos'];
			for (let index = 0; index < numFloors; index += 1) {
				this.floors.push(index + 1);
			}
		} else {
			this.floors = ['Todos'];
		}
		this.loadData();
	}

	async function loadHotel() {
		const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
		this.subsidiaries = subsidiaries.data;
		const subsidiary = subsidiaries.data[0];
		this.params = {
			subsidiaryId: subsidiary.id,
		};
	}

	async function loadRoomtype(id) {
		const idBuilding = id || this.params.buildingId;
		const { data: roomtypes } = await this.$http.get(`${process.env.PMS_URL}/roomtype/${this.params.subsidiaryId}`,
			{ params: { idBuilding } });
		this.params.roomtypesId = 0;
		this.roomTypes = [
			{ id: 0, name: 'Todos' },
		];
		roomtypes.data.forEach((roomType) => {
			this.roomTypes.push(roomType);
		});
	}

	async function loadStates() {
		const { data: states } = await this.$http.get(`${process.env.PMS_URL}/states`);
		this.states = states.data;
		this.params.stateId = 0;
		this.statesFilter = [
			{ id: 0, name: 'Todos' },
		];
		states.data.forEach((state) => {
			this.statesFilter.push(state);
		});
	}

	function onChangeHotel() {
		this.loadBuilding();
		this.loadRoomtype();
		this.loadStates();
	}

	function openModal() {
		this.dialog = true;
	}

	function reservation() {
		this.$router.push({
			name: 'booking-new',
			query: {
				roomId: this.roomsSelected[0].id,
				roomTypeId: this.roomsSelected[0].roomTypes.data.id,
				hotelId: this.params.subsidiaryId,
				initDate: format(new Date(), 'YYYY-MM-DD'),
				endDate: format(addDays(new Date(), 1), 'YYYY-MM-DD'),
			},
		});
	}

	function roomIsSelected(room) {
		if (room.isSelected) {
			this.roomsSelected.push(room);
		} else {
			const index = this.roomsSelected.findIndex(rs => rs.id === room.id);
			this.roomsSelected.splice(index, 1);
		}
	}

	function roomsNotSelected() {
		return this.rooms.every(room => !room.isSelected);
	}

	function stateIsSelected(state) {
		this.states = this.states.map((s) => {
			const newS = { ...s };
			newS.isSelected = s.id === state.id;
			return newS;
		});
		this.stateSelected = { ...state };
	}

	function data() {
		return {
			buildings: [],
			dialog: false,
			floors: [],
			params: {
				subsidiaryId: 0,
			},
			rooms: [],
			roomsSelected: [],
			roomTypes: [],
			states: [],
			statesFilter: [],
			stateSelected: {},
			subsidiaries: [],
		};
	}

	export default {
		name: 'planning-list',
		components: {
			amountsComponent,
			RoomStatus,
		},
		computed: {
			floorsEmpty,
			roomsNotSelected,
			disabledReservation,
		},
		created,
		data,
		filters: {
			round,
		},
		methods: {
			changeState,
			cleanData,
			closeModal,
			loadBuilding,
			loadData,
			loadFloors,
			loadHotel,
			loadRoomtype,
			loadStates,
			onChangeHotel,
			openModal,
			reservation,
			roomIsSelected,
			stateIsSelected,
		},
		mixins: mixin,
	};
</script>

<style lang="scss" scoped>
	.planning-container {
		background-color: white;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, .1);
		padding: 0px 10px 54px;
	}

	.border-bottom {
		border-bottom: 1px solid map-get($map: $colors, $key: bg-subtitle);
	}

	.caption {
		.color {
			border-radius: 3px;
			display: inline-block;
			height: 10px;
			vertical-align: middle;
			width: 10px;
		}

		span {
			display: inline-block;
			height: 20px;

			img {
				vertical-align: middle;
			}
		}

		.title {
			color: map-get($map: $colors, $key: default-label);
			font-family: map-get($map: $fonts, $key: regular);
			font-size: map-get($map: $sizes, $key: twelve) !important;
			vertical-align: middle;
		}
	}

	.action-btn {
		background-color: map-get($map: $colors, $key: button-planning) !important;
		box-shadow: none !important;
		color: white;
		font-family: map-get($map: $fonts, $key: semibold);
		height: 40px;
		max-width: 87px;
		min-width: 87px;
	}

	.reservation-btn {
		background-color: map-get($map: $colors, $key: button-create) !important;
		box-shadow: none !important;
		color: white;
		font-family: map-get($map: $fonts, $key: semibold);
		height: 40px;
		max-width: 146px;
	}

	.icon {
		margin-right: 18px;
	}

	.modal {
		&-card {
			background-color: map-get($map: $colors, $key: default-bg);
		}

		&-row {
			background-color: white;
		}

		&-title {
			color: map-get($map: $colors, $key: default-dark);
			font-family: map-get($map: $fonts, $key: medium);
			font-size: map-get($map: $sizes, $key: fourteen);
		}
	}

	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 52px;
		width: calc(100% - 230px);

		&-calendar {
			margin: 0px !important;
			position: static;
			width: 100%;
		}

		div {
			padding-bottom: 0px !important;
			padding-top: 0px !important;
		}

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}

		.border-select {
			border-right: 1px solid map-get($colors, border-radio);
			margin-right: 16px;
			padding-right: 16px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// List.vue?22f5c407